import type { IBottomNavigationItemProps } from '../types/index'

interface MenuItemsProps extends IBottomNavigationItemProps {
  index: number
  alias: string
}

const MenuItems: MenuItemsProps[] = [
  {
    index: 0,
    icon: 'rdicon-RD-saude',
    iconActive: 'rdicon-RD-saude',
    label: 'início',
    alias: 'início',
  },
  {
    index: 1,
    icon: 'rdicon-view-dashboard',
    iconActive: 'rdicon-view-dashboard-filled',
    label: 'categorias',
    alias: 'categorias',
  },
  {
    index: 2,
    icon: 'rdicon-sale-outline',
    iconActive: 'rdicon-sale-filled',
    label: 'ofertas',
    alias: 'ofertas',
  },
  {
    index: 3,
    icon: 'rdicon-bag',
    iconActive: 'rdicon-bag-filled',
    label: 'pedidos',
    alias: 'pedidos',
  },
  {
    index: 4,
    icon: 'rdicon-person',
    iconActive: 'rdicon-person-filled',
    label: 'perfil',
    alias: 'perfil',
  },
]

export function useBottomNavigation() {
  return {
    MenuItems,
  }
}
